import React from 'react';
import './filterSelect.css';
import Checkbox from "../Checkbox/Checkbox";

const FilterSelect = ({ options, handler, placeholder, open, openHandler, clear }) => {

    let activeOptions = options.filter(el => el.active);
    let values = '';

    activeOptions.forEach((option, index) => {

        if (index + 1 === activeOptions.length) {
            values += option.name;
        }
        else {
            values += option.name + ', ';
        }
    });

    return (
        <div className="select">
            <div className="select__current"
                onClick={ () => openHandler() }
            >
                <div className="select__values">{ values || placeholder }</div>
                {
                    activeOptions.length
                        ? <div className="select__remove" onClick={ event => {
                            event.stopPropagation();
                            clear();
                        } } />
                        : false
                }
            </div>
            <div className={ `select__options ${ open ? 'select__options--open' : '' } ` }>
                {
                    options.map((option, index) => {
                        return (
                            <div
                                key={ index }
                                className="select__option"
                            >
                                <Checkbox
                                    active={ option.active }
                                    caption={ option.name }
                                    handler={ () => handler(option.id) }
                                />
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
};

export default FilterSelect;